import api from './api'
import axios from 'axios'

export const getCategories = async (page, limit) => {
  try {
    let url = '/category'
    if (page !== undefined || (!NaN && limit !== undefined)) {
      url += `?page=${page + 1}&limit=${limit}`
    }
    const category = await api.get(url)
    return category
  } catch (err) {
    console.error('Failed to load categories', err)
  }
}
export const getSingleCategory = async id => {
  try {
    const category = await api.get(`/category/${id}`)
    return category
  } catch (err) {
    console.error('Failed to load Category', err)
  }
}
export const addCategory = async data => {
  try {
    const category = await api.post('/category', data)
    return category
  } catch (err) {
    console.error('Failed to create Category', err)
  }
}

export const updateCategory = async (data, id) => {
  try {
    const category = await api.put(`/category/${id}`, data)
    return category
  } catch (err) {
    console.error('Failed to update Category', err)
  }
}
export const deleteCategory = async id => {
  try {
    const category = await api.delete(`/category/${id}`)
    return category
  } catch (err) {
    console.error('Failed to delete category', err)
  }
}

export const getTemplates = async (page, limit, search) => {
  try {
    let url = '/'
    if (
      page !== undefined &&
      !isNaN(page) &&
      limit !== undefined &&
      search !== undefined
    ) {
      url += `?page=${page + 1}&limit=${limit}&search=${search}`
    }
    const templates = await api.get(url)
    return templates
  } catch (err) {
    console.error('Failed to load templates', err)
  }
}

export const getAssignedTemplates = async ({ startDate, endDate } = {}) => {
  try {
    let url = '/dashboard'

    if (startDate && endDate) {
      const query = new URLSearchParams({ startDate, endDate }).toString()
      url += `?${query}`
    }

    const templates = await api.get(url)
    return templates
  } catch (err) {
    console.error('Failed to load templates:', err)
    throw err // Optional: rethrow to handle in component
  }
}

export const getDashBoardStats = async () => {
  try {
    const templates = await api.get('/dashboard/stats')
    return templates
  } catch (err) {
    console.error('Failed to load templates', err)
  }
}

export const generatePreviewTemplate = async text => {
  try {
    const res = await axios.post('/api/generate-preview', {
      content: text,
    })
    return res.data
  } catch (err) {
    console.error('generatePreviewTemplate failed:', err)
    return null
  }
}

export const generateCount = async data => {
  try {
    const result = await api.post('/generated-count', data)
    return result
  } catch (err) {
    console.error('Failed to create template', err)
  }
}

export const saveTenplate = async content => {
  try {
    const data = { content }
    const result = await api.post('/', data)
    return result
  } catch (err) {
    console.error('Failed to create template', err)
  }
}

export const updateTenplate = async (content, id) => {
  try {
    const data = { content }
    const result = await api.put(`/${id}`, data)
    return result
  } catch (err) {
    console.error('Failed to create template', err)
  }
}

export const deleteTenplate = async template => {
  try {
    const result = await api.delete('/' + template.id)
    return result
  } catch (err) {
    console.error('Failed to delete template', err)
  }
}

export const checkAUth = () => {
  return !!localStorage.getItem('_atk')
}

export const login = async ({ email, password }) => {
  try {
    const data = { email, password }

    const result = await api.post('/login', data)
    localStorage.setItem('_atk', result)
    return true
  } catch (err) {
    console.error('Failed to login', err)
  }
}

export const addUser = async data => {
  try {
    const newData = { ...data, user: data.email }
    const result = await api.post('/users', newData)
    return result
  } catch (err) {
    // console.error('Failed to Add User', err)
    return err
  }
}

export const usersList = async (page, limit) => {
  try {
    let url = '/users'
    if (page !== undefined && !isNaN(page) && limit !== undefined) {
      url += `?page=${page + 1}&limit=${limit}`
    }
    const result = await api.get(url)
    return result
  } catch (err) {
    console.error('Failed to Add User', err)
  }
}

export const singleUser = async id => {
  try {
    const result = await api.get(`/users/${id}`)
    return result
  } catch (err) {
    console.error('Failed to fetch user', err)
    throw err // rethrow so the caller knows it failed
  }
}

export const deleteUser = async id => {
  try {
    const result = await api.delete(`/users/${id}`)
    return result
  } catch (error) {
    return error
  }
}

export const updateUser = async (id, data) => {
  try {
    const result = await api.put(`/users/${id}`, data)
    return result
  } catch (error) {
    return error
  }
}

export const updateLastActive = async (id, data) => {
  try {
    const result = await api.put(`/last-active/${id}`, { lastLogin: data })
    return result
  } catch (error) {
    return error
  }
}

export const validateEmial = async (id, email) => {
  const data = {
    userId: id,
    email: email,
  }
  try {
    const result = await api.post(`/users/validate-email`, data)
    return result
  } catch (error) {
    return error
  }
}

export const listValidatedEmail = async () => {
  try {
    const result = await api.get(`/email-validations`)
    return result
  } catch (error) {
    return error
  }
}

export const listValidatedEmailbySingleUser = async (userId, filters = {}) => {
  try {
    const sanitizedFilters = Object.fromEntries(
      Object.entries(filters).filter(
        ([_, value]) => value !== undefined && value !== null && value !== '',
      ),
    )
    const queryString = new URLSearchParams(sanitizedFilters).toString()
    const result = await api.get(`/email-validations/${userId}?${queryString}`)
    return result
  } catch (error) {
    return error
  }
}

export const getUsertemplateGenerations = async (filters = {}) => {
  try {
    const sanitizedFilters = Object.fromEntries(
      Object.entries(filters).filter(
        ([_, value]) => value !== undefined && value !== null && value !== '',
      ),
    )
    const queryString = new URLSearchParams(sanitizedFilters).toString()
    const result = await api.get(`/usertemplategenerations?${queryString}`)

    return result
  } catch (error) {
    console.error('Failed to fetch user template generations', error)
    return error
  }
}

export const getUserTemplateGenerationsById = async (userId, filters = {}) => {
  try {
    const sanitizedFilters = Object.fromEntries(
      Object.entries(filters).filter(
        ([_, value]) => value !== undefined && value !== null && value !== '',
      ),
    )
    const queryString = new URLSearchParams(sanitizedFilters).toString()
    const result = await api.get(`/usertemplategenerations/${userId}?${queryString}`)
    return result
  } catch (error) {
    return error
  }
}

export const getTemplateUserGenerations = async (filters = {}) => {
  try {
    const sanitizedFilters = Object.fromEntries(
      Object.entries(filters).filter(
        ([_, value]) => value !== undefined && value !== null && value !== '',
      ),
    )
    const queryString = new URLSearchParams(sanitizedFilters).toString()
    const result = await api.get(`/templateUserGenerations?${queryString}`)

    return result
  } catch (error) {
    console.error('Failed to fetch user template generations', error)
    return error
  }
}

export const getTemplateUserGenerationsById = async (templateId, filters = {}) => {
  try {
    const sanitizedFilters = Object.fromEntries(
      Object.entries(filters).filter(
        ([_, value]) => value !== undefined && value !== null && value !== '',
      ),
    );
    const queryString = new URLSearchParams(sanitizedFilters).toString();
    const response = await api.get(`/templateUserGenerations/${templateId}?${queryString}`);
    return response;
  } catch (error) {
    console.error('API error in getTemplateUserGenerationsById:', error);
    throw error; // Better to throw than return raw error
  }
};


export const generateEmail = async (data) => {
  try {
    const result = await api.post('mail-generation/generate', data);
    console.log("Generated email response:", result);
    return result;
  } catch (error) {
    console.log("Failed to generate email", error);
    throw error;
  }
};

export const GetallEmails = async () => {
  try {
    const result = await api.get('/mail-generation/getallemails');
    return result;
  }
  catch (err) {
    throw err;
  }
}

export const GetallPrompts = async () => {
  try {
    const result = await api.get('/mail-generation/getall');
    return result;
  }
  catch (err) {
    throw err;
  }
}


export const UpdatePrompt = async (id, newprompt) => {
  try {
    const result = await api.put(`/mail-generation/edit/${id}`, {
      prompt: newprompt
    });
    return result;
  }
  catch (err) {
    throw err;
  }
}
